import Form from "components/Form";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import masks from "utils/form/masks";
import { required, validCellPhone, validEmail, validOptionalPhone } from "utils/form/validations";

const DadosContato = ({ validationRef, initialValue }) => {
  return (
    <section>
      <Section>
        <ResponsiveCard maxContent title="Dados de contato">
          <Form.Section validationRef={validationRef} scheme={initialValue}>
            <Form.Input
              name="celular"
              label="Telefone celular"
              placeholder="Apenas números"
              validationRules={[required, validCellPhone]}
              half
              mask={masks.phone}
            />
            <Form.Input
              name="telefone"
              label="Outro telefone"
              placeholder="Apenas números"
              validationRules={[validOptionalPhone]}
              half
              optionalLabel="Opcional"
              mask={masks.phone}
            />
            <Form.Input
              name="email"
              label="E-mail"
              placeholder="Informe um e-mail válido"
              validationRules={[required, validEmail]}
              mask={masks.maxLength(50)}
            />
          </Form.Section>
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default DadosContato;
